// Recovered compiled webpack factory 65971. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { X: () => r });
  var n = i(27290),
    s = i(38857);
  function r(t, e = 100, i) {
    let o = i({ ...t, keyframes: [0, e] }),
      a = Math.min((0, s.t)(o), s.Y);
    return { type: "keyframes", ease: (t) => o.next(a * t).value / e, duration: (0, n.X)(a) };
  }
}
